import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ScrollableWithGradients } from "@rentablo/components";
import { DetailCards } from "@features/recommender/components/DetailCard/DetailCard";
import { PerformanceNumbers } from "@features/performance";
import { getCards } from "../utils";
import { useRecommendationDetails } from "../RecommendationDetailsProvider";
import { HeaderSection } from "../components";
import {
  FeeCostSection,
  PerformanceSection,
  QuoteComparisonSection,
  RiskPerformanceSection,
} from "./components";
import {
  HoldingsSection,
  IndustrySection,
  RegionSection,
} from "./components/breakdown";
import { ProductInfoSection } from "./components/productInfo/ProductInfoSection";

interface Props {
  onClose: () => void;
}

export const CompareView = ({ onClose }: Props) => {
  const { t } = useTranslation();
  const { recommendation, quote } = useRecommendationDetails();
  const cardsData = getCards(recommendation);

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <HeaderSection onClose={onClose} />
      <ScrollableWithGradients sx={{ pr: 2 }}>
        <PerformanceNumbers
          primaryValue={quote?.last ?? 0}
          secondaryValue={quote?.changePercent ?? 0}
          containerSx={{
            mb: 4,
            mt: 8,
          }}
        />
        <DetailCards cards={cardsData} isSmallerFontSize />
        <Typography variant="subtitle2" mt={4} mb={3}>
          {t("recommender.compareView.title")}
        </Typography>
        <QuoteComparisonSection />
        <Divider sx={{ mt: -1, mb: 8 }} />
        <PerformanceSection />
        <RiskPerformanceSection />
        <Divider sx={{ mt: 8, mb: 4 }} />
        <FeeCostSection />
        <RegionSection />
        <IndustrySection />
        <HoldingsSection />
        <ProductInfoSection />
      </ScrollableWithGradients>
    </Box>
  );
};
